export function GenerateId() {

    const characters = '23456789BCDFGHJKMNPQRSTVWXYZ';

    let merchantId = '';

    for (let i = 0; i < 7; i++) {
        merchantId += characters[Math.floor(Math.random() * 28)];
    }

    return merchantId;
}


// WEBPACK FOOTER //
// ./src/Components/WorldNet/IdGeneration.ts